// Elements that fade in on first view. `interval` staggers siblings.
export const targetElements = [
  { element: ".hero-kicker" },
  { element: ".hero-title" },
  { element: ".hero-intro" },
  { element: ".hero-cta" },
  { element: ".social-links" },
  { element: ".hero-portrait" },
  { element: ".section-title" },
  { element: ".contact-channel" },
];
